/**
 * chaiguy-nav.js
 * Handles the Shop dropdown for ChaiGuyLA navbar.
 *
 * Desktop: mouseenter on wrapper opens immediately; mouseleave starts a
 *   short timer. If the mouse enters the dropdown menu before the timer
 *   fires, the close is cancelled. This bridges the visual gap between
 *   the trigger button and the dropdown panel so the menu never
 *   disappears mid-travel.
 *
 * Mobile/Tablet (<990px): tap the trigger to toggle. Tap outside to close.
 */
(function () {
  'use strict';

  var CLOSE_DELAY = 180; // ms — enough to cross the 8px gap comfortably

  function closeAll(except) {
    document.querySelectorAll('.chaiguy-dropdown-wrapper.is-open').forEach(function (w) {
      if (w === except) return;
      w.classList.remove('is-open');
      var t = w.querySelector('.chaiguy-shop-trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  function initChaiGuyNav() {
    var wrappers = document.querySelectorAll('.chaiguy-dropdown-wrapper');
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
      var trigger = wrapper.querySelector('.chaiguy-shop-trigger');
      var menu    = wrapper.querySelector('.chaiguy-dropdown-menu');
      if (!trigger || !menu) return;

      var closeTimer = null;

      /* ── Helpers ─────────────────────────────────────────── */
      function open() {
        clearTimeout(closeTimer);
        closeAll(wrapper);
        wrapper.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }

      function scheduleClose() {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          wrapper.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }, CLOSE_DELAY);
      }

      function cancelClose() {
        clearTimeout(closeTimer);
      }

      /* ── Desktop: hover with delay-close ─────────────────── */
      wrapper.addEventListener('mouseenter', function () {
        if (window.innerWidth < 990) return;
        open();
      });

      wrapper.addEventListener('mouseleave', function () {
        if (window.innerWidth < 990) return;
        scheduleClose();
      });

      // Keep open while mouse travels through the gap into the menu
      menu.addEventListener('mouseenter', function () {
        if (window.innerWidth < 990) return;
        cancelClose();
      });

      menu.addEventListener('mouseleave', function () {
        if (window.innerWidth < 990) return;
        scheduleClose();
      });

      /* ── Mobile/Tablet: tap toggle ───────────────────────── */
      trigger.addEventListener('click', function (e) {
        if (window.innerWidth >= 990) return;
        e.preventDefault();
        e.stopPropagation();

        var isOpen = wrapper.classList.contains('is-open');
        closeAll(null);
        if (!isOpen) open();
      });
    });

    /* ── Global close on outside click / Escape ──────────────── */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.chaiguy-dropdown-wrapper')) {
        closeAll(null);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  }

  /* Run after DOM is ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChaiGuyNav);
  } else {
    initChaiGuyNav();
  }
})();
